import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      color: '#1e293b',
      lineHeight: 1.6,
      padding: '40px 20px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        maxWidth: '860px',
        margin: '0 auto',
        background: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08)',
        border: '1px solid #e2e8f0',
        padding: '36px 32px',
        boxSizing: 'border-box'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #e2e8f0',
          paddingBottom: '20px',
          marginBottom: '28px',
          flexWrap: 'wrap',
          gap: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <img
              src={process.env.PUBLIC_URL + '/Lotus_logo.jpeg'}
              alt="Lotus Logo"
              style={{
                width: '54px',
                height: '54px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #3b82f6'
              }}
            />
            <div>
              <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 800, color: '#0f172a' }}>
                Lotus Preschool
              </h1>
              <span style={{ fontSize: '13px', color: '#64748b' }}>
                Privacy Policy &amp; Data Protection Statement
              </span>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button
              type="button"
              onClick={() => window.print()}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #3b82f6',
                background: '#eff6ff',
                color: '#2563eb',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6
              }}
            >
              🖨️ Print / Save PDF
            </button>
            <button
              type="button"
              onClick={() => navigate('/login')}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #cbd5e1',
                background: '#f8fafc',
                color: '#334155',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              ← Back to Login
            </button>
          </div>
        </div>

        {/* Meta info */}
        <div style={{
          background: '#eff6ff',
          border: '1px solid #bfdbfe',
          borderRadius: '10px',
          padding: '12px 18px',
          fontSize: '13px',
          color: '#1e40af',
          marginBottom: '28px'
        }}>
          <strong>Effective Date:</strong> January 1, 2026 | <strong>Last Updated:</strong> September 15, 2026
        </div>

        {/* Content sections */}
        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            1. Introduction
          </h2>
          <p style={{ margin: 0, fontSize: '14px', color: '#475569' }}>
            Lotus Preschool (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) is committed to protecting the privacy and personal data of our students, parents, guardians, teachers, and staff. This Privacy Policy describes how we collect, use, store, and safeguard your information when you use the Lotus Preschool Mobile Applications (Lotus Parent, Lotus Teacher) and our Web Admin Management Portal (the &ldquo;Services&rdquo;).
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            2. Information We Collect
          </h2>
          <p style={{ fontSize: '14px', color: '#475569', marginBottom: '10px' }}>
            To provide comprehensive preschool management and early childhood education tracking, we may collect the following types of information:
          </p>
          <ul style={{ fontSize: '14px', color: '#475569', paddingLeft: '22px', margin: 0 }}>
            <li style={{ marginBottom: '6px' }}>
              <strong>Student Profile Data:</strong> Full name, date of birth, age, assigned class/branch, dietary requirements, emergency contacts, allergy details, and attendance records.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <strong>Parent / Guardian Information:</strong> Full name, verified mobile phone number, email address, relationship to student, and authorized pickup credentials.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <strong>Teacher &amp; Staff Information:</strong> Name, contact details, assigned branches/classes, and activity management logs.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <strong>Educational &amp; Daily Activity Media:</strong> Photos, activity logs (learning activities, meals, nap times), milestones, and daily developmental feedback captured exclusively by verified teachers.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <strong>Device &amp; Usage Information:</strong> Device model, OS version, Firebase Cloud Messaging (FCM) tokens for push notifications, and login timestamps for security audits.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            3. How We Use the Information
          </h2>
          <ul style={{ fontSize: '14px', color: '#475569', paddingLeft: '22px', margin: 0 }}>
            <li style={{ marginBottom: '6px' }}>To facilitate day-to-day preschool operations, attendance marking, and developmental activity reporting.</li>
            <li style={{ marginBottom: '6px' }}>To deliver real-time push notifications to parents regarding daily activities, child check-in/check-out, emergency alerts, and announcements.</li>
            <li style={{ marginBottom: '6px' }}>To maintain strict security around student pickup authorizations.</li>
            <li style={{ marginBottom: '6px' }}>To process session rollovers and grade promotions in compliance with early learning stages.</li>
            <li style={{ marginBottom: '6px' }}>We do <strong>NOT</strong> sell, rent, monetize, or trade any personal or student information to third parties or advertising networks.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            4. Children&apos;s Privacy (COPPA &amp; POPIA Compliance)
          </h2>
          <p style={{ margin: 0, fontSize: '14px', color: '#475569' }}>
            Our application is designed for use by educational institutions, authorized teachers, and parents. Children do not directly create accounts or interact with the app. Student information and classroom activity media are entered exclusively by verified school personnel with parental consent under the Protection of Personal Information Act (POPIA - South Africa) and Children&apos;s Online Privacy Protection Act (COPPA) guidelines.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            5. Device Permissions &amp; Access
          </h2>
          <p style={{ fontSize: '14px', color: '#475569', marginBottom: '8px' }}>
            Our mobile applications may request the following permissions only when required for core functionality:
          </p>
          <ul style={{ fontSize: '14px', color: '#475569', paddingLeft: '22px', margin: 0 }}>
            <li style={{ marginBottom: '6px' }}><strong>Camera / Photos:</strong> For teachers to upload student profile pictures or activity photos.</li>
            <li style={{ marginBottom: '6px' }}><strong>Push Notifications:</strong> To alert parents and staff about daily updates, announcements, and urgent school notices.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            6. Data Security &amp; Storage
          </h2>
          <p style={{ margin: 0, fontSize: '14px', color: '#475569' }}>
            We implement industry-standard security safeguards including encrypted HTTPS/TLS data in transit, encrypted password hashing (bcrypt), token-based JWT authentication, and secure database storage protected behind restricted firewalls.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            7. Data Retention &amp; Account Deletion Policy
          </h2>
          <p style={{ margin: '0 0 10px', fontSize: '14px', color: '#475569' }}>
            We retain account and student records only as long as necessary to provide educational management services or as required by South African educational compliance laws.
          </p>
          <p style={{ margin: 0, fontSize: '14px', color: '#475569' }}>
            <strong>How to request account or data deletion:</strong> Parents or staff may request full deletion of their personal information and associated records by submitting an email request to <a href="mailto:loexa2026@gmail.com" style={{ color: '#2563eb', fontWeight: 600 }}>loexa2026@gmail.com</a> or through school administration. We will process and confirm deletion within 30 business days.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            8. Changes to This Privacy Policy
          </h2>
          <p style={{ margin: 0, fontSize: '14px', color: '#475569' }}>
            We may periodically update this policy to reflect legal, regulatory, or operational enhancements. Any material revisions will be reflected with an updated &ldquo;Last Updated&rdquo; timestamp and notified via the app or email.
          </p>
        </section>

        <section style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
          <h2 style={{ fontSize: '18px', color: '#1e293b', fontWeight: 700, marginBottom: '10px' }}>
            9. Contact Us
          </h2>
          <p style={{ margin: '0 0 6px', fontSize: '14px', color: '#475569' }}>
            If you have any questions, concerns, or requests regarding this Privacy Policy, please reach out to us:
          </p>
          <div style={{ fontSize: '14px', color: '#334155', lineHeight: 1.8 }}>
            <strong>Organization:</strong> Lotus Preschool &amp; Early Learning Centre<br />
            <strong>Email:</strong> <a href="mailto:loexa2026@gmail.com" style={{ color: '#2563eb' }}>loexa2026@gmail.com</a><br />
            <strong>Location:</strong> South Africa
          </div>
        </section>

        <div style={{
          marginTop: '32px',
          textAlign: 'center',
          fontSize: '12px',
          color: '#94a3b8',
          borderTop: '1px solid #f1f5f9',
          paddingTop: '16px'
        }}>
          &copy; {new Date().getFullYear()} Lotus Preschool. All rights reserved.
        </div>
      </div>
    </div>
  );
}
